import { render } from "./BalLoadingNumber.vue?vue&type=template&id=395fe40f"
import script from "./BalLoadingNumber.vue?vue&type=script&lang=ts"
export * from "./BalLoadingNumber.vue?vue&type=script&lang=ts"
script.render = render

export default script